
import {throwError as observableThrowError,  Observable ,  Subject } from 'rxjs';

import {switchMap, distinctUntilChanged, debounceTime, catchError, map} from 'rxjs/operators';
// import { AppConstant } from './../../shared/constant/app.constant';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';
import { AppConfigService } from '../../shared/services/app.config.service';
import { AuthenticationService } from 'app/admin/services';

let AppConstant: any = {};
@Injectable()
export class ReportService {


    constructor(private http: AuthHttp, private appConfigServ: AppConfigService, private authService: AuthenticationService) {
        AppConstant = appConfigServ;
    }
    getLoanApplicationSLA(applicationId: number) {
        return this.http.get(`report/workflowsla/loanapplication/${applicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLoanRepaymentSchedule(teamLoanId: number) {
        return this.http.get(`report/loans/loanschedule/${teamLoanId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getSectorLimit() {
        return this.http.get(`report/limitmonitoring/sector`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getBranchLimit() {
        return this.http.get(`report/limitmonitoring/branch`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getWorkflowDefinition(id: number) {
        return this.http.get(`report/workflow-definition/operation/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getDisburstLoanReport(data) {
        return this.http.post(`report/loan-disbursedloans`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getRunningFacilitiesReport(data) {
        return this.http.post(`report/running-facilities`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getBlacklistReport(data) {
        return this.http.post(`report/camsol/blacklist`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanCommercialReport(data) {
        return this.http.post(`report/loan-commercial`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getTeamandRevolving(data) {
        return this.http.post(`report/loan-team-revolving`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    exportApprovalComments(data, requireAll = false) {
        return this.http.post(`setups/approval-comments/export/${requireAll}`, data)
        .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getEarnedUnearnedInterest(data) {
        return this.http.post(`report/loan-earned-unearned-interest`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getfinancePostedTransactions(data) {
        return this.http.post(`report/posted-finance-transactions`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getStaffPosting(data) {
        return this.http.post(`report/posted-transactions-staff/date`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    //#region Offer-Letter Generation & Loan-Monitoring Reports

    getGeneratedOfferLetterCFL(applicationRefNumber: string) {
        return this.http.get(`report/offer-letter-cfl/?applicationRefNumber=${applicationRefNumber}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getGeneratedOfferLetter(applicationRefNumber: string) {
        return this.http.get(`report/offer-letter/?applicationRefNumber=${applicationRefNumber}`).pipe(
            map((res: any) => {
                console.log("getGeneratedOfferLetter");
                if(res && res['success'] && res['result']) {
                    res['result'] = res.result.replace(AppConstant.REPORT_BASE_URL,AppConstant.APP_HOST);
                    res['result'] = `${res['result']}&secret=${this.authService.getToken()}` 
                }
                console.log(res);
                return res;
            }),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getGeneratedOfferLetterLMS(applicationRefNumber: string) {
        return this.http.get(`report/offer-letter-lms/?applicationRefNumber=${applicationRefNumber}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getCollateralPropertyRevaluationReport(data) {
        return this.http.post(`report/monitoring/collateral-property-revaluation`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getStalledPerfectioneport(data) {
        return this.http.post(`report/stalled-perfection`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralPerfectionYetToCommenceReport(data) {
        return this.http.post(`report/collateral-perfection-yettocommence`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCashBacked(data) {
        return this.http.post(`report/cashbacked-Report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getAllCommercialLoanReport(data) {
        return this.http.post(`report/all-comercial-loan-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getUnearnedInterest(data) {
        return this.http.post(`report/unearned-interest-Report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getReceivedInterest(data) {
        return this.http.post(`report/receivable-interest-Report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getCashBackedBondGuarantee(data) {
        return this.http.post(`report/cashbacked-bond-guarantee`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getweeklyrecoveryReportforFINCON(data) {
        return this.http.post(`report/weeklyrecovery-Reportfor-FINCON`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCashCollaterizedCredits(data) {

        return this.http.post(`report/cash-collaterized-credits`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }


    getCovenantsApproachingDueDateReport(data) {
        return this.http.post(`report/monitoring/almost-due-covenants`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getNonPerformingLoansReport(form) {
        return this.http.post(`report/monitoring/non-performing-loans`, form).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getBondAndGuaranteeReport(form) {
        return this.http.post(`report/monitoring/bond-and-guarantee`, form).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getCollateralVisitationReport(form) {
        return this.http.post(`report/monitoring/property-due-for-vistation`, form).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getInsuranceExpiraionReport(form) {
        return this.http.post(`report/monitoring/insurance-expiration`, form).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getTurnoverCovenantReport(form) {
        return this.http.post(`report/monitoring/turnover-covenant`, form).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getExpiredSelfLiquidatingLoansReport(data) {
        return this.http.post(`report/monitoring/expired-self-liquidating-loans`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getExpiredOverdraftLoansReport(data) {
        return this.http.post(`report/monitoring/overdraft-loans`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getLoanStatement(id: number) {
        return this.http.get(`report/loanstatement/loan/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetLoanAnniverseryReport(data) {
        return this.http.post(`report/loan-LoanAnniversery`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetLoanDocumentWaived(data) {
        return this.http.post(`report/loan/document-waived`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetLoanDocumentDeferred(data) {
        return this.http.post(`report/loan/document-deferred`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetLoanClassification(data) {
        return this.http.post(`report/loan-classification-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetAgeAnalysisReport(data) {
        return this.http.post(`report/age-analysis-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetDisbursalCreditTurnoverReport(data) {
        return this.http.post(`report/disbursal-credit-turnover`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    // GetImpairedWatchListReport(data) {
    //     return this.http.post(`report/impaired-watch-list-report`, data)
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    //}

    
    GetImpairedWatchListReport(data) {
        return this.http.post(`report/impaired-watch-list-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetInsuranceReport() {
        return this.http.get(`report/insurance-report`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetExpiredReport(data) {
        return this.http.post(`report/expired-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetRuniningLoanReport(data) {
        return this.http.post(`report/runining-loan-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetExcessReport(data) {
        return this.http.post(`report/excess-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    GetUnutilizedFacilityReport() {
        return this.http.get(`report/unutilized-facility-report`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetSanctionLimitReport(data) {
        return this.http.post(`report/sanction-limit-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetLoanDocumentDefferals(data) {
        return this.http.post(`report/loan/document-deferrals`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetLoanDocumentDefferalsMCC(data) {
        return this.http.post(`report/loan/document-deferrals-mcc`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetFacilityApprovedNotUtilized(data) {
        return this.http.post(`report/loan/facility-approved-not-utilized`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetRuningLoansByLaonType(data) {
        return this.http.post(`report/loan/runing-loans-by-loantype`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetLoanInterestReceivableAndPayable(data) {
        return this.http.post(`report/loan/loan-interest-receivable-and-payable`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getCollateralEstimated(collateralCode: string) {
        return this.http.get(`report/collateralestimated/loan/${collateralCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetFCYScheuledLoan(id: number) {
        return this.http.get(`report/fcyscheuledloan/loan/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getLoanAccountWithLein(data) {
        return this.http.post(`report/account-with-lien`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetStakeholderWithExpiredFTP(data) {
        return this.http.post(`report/stakeholders-on-experation-ftp`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetAuditTrail(data) {
        return this.http.post(`report/audit-trail`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetLoggingStatus(data) {
        return this.http.post(`report/login-status`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetLAReport(data) {
        return this.http.post(`report/workflow/sla-monitoring`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetAllApprovalStatus() {
        return this.http.get(`setups/work-flow-tracker/approval-status`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetAllApprovalOperations() {
        return this.http.get(`setups/work-flow-tracker/approval-operation`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetAllDailyAccrualCategories() {
        return this.http.get(`report/daily-accrual/categories`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetAllDailyAccrualReport(data) {
        return this.http.post(`report/daily-accrual`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetLoanRepaymentReport(data) {
        return this.http.post(`report/repayment`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetCustomFacilityRepaymentReport(data) {
        return this.http.post(`report/custom-facility-repayment`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetAllLoanTransactionType() {
        return this.http.get(`report/loan-transaction/type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    SearchForBranch(term) {
        return this.http
            .get(`setups/branch-search?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }
    BranchSearchObservable(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.SearchForBranch(term)),);
    }
    SearchForAuditType(term) {
        return this.http
            .get(`report/audit-search?searchQuery=${term}`).pipe(
            map((res: any) => res));
    }
    AuditTypeSearchObservable(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.SearchForAuditType(term)),);
    }
    GetOperations() {
        return this.http.get(`report/operations`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetFlowType() {
        return this.http.get(`report/flow-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    GLSearchObservable(terms: Observable<any>) {
        return terms.pipe(debounceTime(400),
            distinctUntilChanged(),
            switchMap(term => this.SearchForGL(term)),);
    }
    SearchForGL(searchQuery) {
        return this.http
            .get(`report/gl-search/${searchQuery}`).pipe(
            map((res: any) => res));
    }

    SearchForGLList(searchQuery) {
        return this.http
            .get(`report/accountcode-search?searchQuery=${searchQuery}`).pipe(
            map((res: any) => res));
    }
    getPrintLetter(applicationRefNumber: string) {
        return this.http.get(`report/form3800b-los/?applicationRefNumber=${applicationRefNumber}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    printLMSForm3800B(applicationRefNumber: string) {
        return this.http.get(`report/form3800b-lms/?applicationRefNumber=${applicationRefNumber}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    Getproductclass() {

        return this.http
            .get(`report/dropdown-product-class`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }
    GetStaffPrivilegeChange(data) {
        return this.http.post(`report/staff-priviledge-change-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    GetUserGroupChangeReport(data) {
        return this.http.post(`report/user-group-change-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetProfileActivityReport(data) {
        return this.http.post(`report/profile-activity-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetStaffRoleProfileGroupReport(data) {
        return this.http.post(`report/staff-role-profile-group-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetStaffRoleProfileActivityReport(data) {
        return this.http.post(`report/staff-role-profile-activity-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetInActiveContigentLiabilityReport(data) {
        return this.http.post(`report/inactive-contigent-liability-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetAllLoanStatus() {
        return this.http.get(`report/dropdown-loan-status`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    GetMiddleOfficeReport(data) {
        return this.http.post(`report/middle-office-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetCollateralValuationReport(data) {
        return this.http.post(`report/collateral-valuation-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetCreditScheduleReport(data) {
        return this.http.post(`report/credit-schedule-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetOfferLetterTitle(customerId) {
        return this.http.get(`credit/offer-letter/get/title/${customerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetOfferLetterSalutation(customerId) {
        return this.http.get(`credit/offer-letter/get/salutation/${customerId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetOfferLetterClause(loanApplicationId) {
        return this.http.get(`credit/offer-letter/get/clauses/${loanApplicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    GetOfferLetterAcceptance(loanApplicationId) {
        return this.http.get(`credit/offer-letter/get/acceptance/${loanApplicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    UpdateOfferLetterClause(data) {
        return this.http.post(`credit/offer-letter/edit/clause`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    UpdateOfferLetterAcceptance(data) {
        return this.http.post(`credit/offer-letter/edit/acceptance`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    UpdateOfferLetterTitle(data) {
        return this.http.post(`credit/offer-letter/edit/title`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    UpdateOfferLetterSalutation(data) {
        return this.http.post(`credit/offer-letter/edit/salutation`, JSON.stringify(data)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    LoanBookingReport(data) {
        return this.http.post(`report/loan-booking-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    Fom3800bReport(data) {
        return this.http.post(`report/form3800b-report`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    generateOoutPutDocument(loanApplicationId) {
        return this.http.get(`report/output-document/loanApplicationId/${loanApplicationId}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getOriginalDocument(data) {
        return this.http.post(`report/original-document-submission`, data).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
   
   
    GetExpiredFacilityReport(body) {
        return this.http.post(`report/expired-facility-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetContigentReport(body) {
        return this.http.post(`report/contigent-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
        // benjamin
    GetRiskAssetsReport(body) {
        return this.http.post(`report/risk-assets-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetcbnNplTeamReport(body) {
        return this.http.post(`report/cbn-npl-team-report`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    
    GetRiskAssetByCbnNplClassificationReport(body) {
        return this.http.post(`report/risk-asset-by-cbn-classification`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetContigentLiabilityReportMain(body) {
        return this.http.post(`report/contigent-liability-report`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

   

    GetContigentLiabilityReport(body) {
        return this.http.post(`report/contigent-liability`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetContigentLiabilityReportMain1(body) {
        return this.http.post(`report/contigent-liability-main`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetCopyOfRiskAssetMain(body) {
        return this.http.post(`report/copy-of-risk-asset-main`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetCalcCombine(body) {
        return this.http.post(`report/calc-combine`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetCalcCombineReport(body) {
        return this.http.post(`report/risk-calc-combine`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    
    GetCopyOfRiskAssetByIfrsClassifications(body) {
        return this.http.post(`report/copy-of-risk-ifrs`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getOverlineReport(body) {
        return this.http.post(`report/overline-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetLargeExposureReport(body) {
        return this.http.post(`report/large-exposure-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetExtensionReport(body) {
        return this.http.post(`report/extension-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetMaturityReport(body) {
        return this.http.post(`report/maturity-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetIfrsClassificationTeamReport(body) {
        return this.http.post(`report/ifrs-classification-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetByVarianceReport(body) {
        return this.http.post(`report/risk-asset-variance-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetCombinedReport(body) {
        return this.http.post(`report/risk-asset-combined-report`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetContigentReportMain(body) {
        return this.http.post(`report/risk-contigent-main`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetCopyOfRiskAssetByIfrsClassification(body) {
        return this.http.post(`report/copy-ifrs-classification`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetMainReport(body) {
        return this.http.post(`report/risk-asset-main-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetMain1Report(body) {
        return this.http.post(`report/risk-asset-main1-report`,JSON.stringify(body))
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetDistributionBySectorReport(body) {
        return this.http.post(`report/risk-asset-distribution-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetTeamReport(body) {
        return this.http.post(`report/risk-asset-team-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetUnpaidObligationReport(body) {
        return this.http.post(`report/unpaid-obligation-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetRiskAssetByIFRSClassificationReport(body) {
        return this.http.post(`report/rest-classification-report`,JSON.stringify(body)).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    isOfferLetterGenerated(data) {
        return this.http.post(`credit/offer-letter/is-offer-letter-generated`, data)
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    ApplyTemplateToOfferLetter(data) {
        return this.http.post(`credit/offer-letter/apply-template`, data)
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetApprovalMointoring(data) {
        return this.http.post(`setups/work-flow-tracker/approval-monitoring`, data)
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    GetBookingMointoring(data) {
        return this.http.post(`setups/work-flow-tracker/approval-booking-monitoring`, data)
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getApprovalTrailByTargetId(targetId) {
        return this.http.get(`setups/work-flow-tracker/target/${targetId}`)
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getBookingApprovalTrailByTargetId(targetId) {
        return this.http.get(`setups/work-flow-tracker/booking/target/${targetId}`)
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    exportApprovalMonitoringExportToExcel(data) {
        return this.http.post(`setups/approval-monitoring/export`, data)
            .pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}

